var render = function render(){var _vm=this,_c=_vm._self._c;return _c("button",{tag:"component",class:_vm.genetatedClass,attrs:{"disabled":_vm.disable},on:{"click":function($event){$event.preventDefault();return _vm.$emit('event', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }